<template>
  <layout-ucenter>
    <!-- menu -->
    <template slot="menu">
      <!-- 供应商 & 管理员 -->
      <el-menu v-if="user.type == 3" mode="vertical" :router="true" default-active="1">
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-document"></i> 广告管理</template>
          <el-menu-item index="/ad/stats">广告统计</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-setting"></i> 账户管理</template>
          <el-menu-item index="/account/accountuser">客户账单</el-menu-item>
          <el-menu-item index="/account/soundtooth">声牙账单</el-menu-item>
        </el-menu-item-group>
      </el-menu>
      <!-- 普通用户 -->
      <el-menu v-else mode="vertical" :router="true" default-active="1">
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-document"></i> 广告管理</template>
          <el-menu-item index="/ad/stats">广告统计</el-menu-item>
          <el-menu-item index="/ad/create">新建广告</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-upload"></i> 盒子管理</template>
          <el-menu-item index="/box/list">盒子列表</el-menu-item>
          <el-menu-item index="/box/create">添加盒子</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-setting"></i> 账户管理</template>
          <el-menu-item index="/account/recharge">账户充值</el-menu-item>
          <el-menu-item index="/account/top-up">财务报表</el-menu-item>
        </el-menu-item-group>
      </el-menu>
    </template>
  </layout-ucenter>
</template>

<script>
  import layoutUcenter from './layout-ucenter'
  import authService from 'service/authService'

  export default {
    components: {
      layoutUcenter
    },

    computed: {
      user () {
        return authService.currentUser
      }
    }
  }
</script>

<style>
.el-menu {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// ad-container.vue?7658bbdc